"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
require("swiper/swiper.scss");
require("swiper/components/navigation/navigation.scss");
require("swiper/components/scrollbar/scrollbar.scss");
require("swiper/components/pagination/pagination.min.css");
var i18next_1 = require("i18next");
var NewTop_1 = __importDefault(require("./sections/NewTop/NewTop"));
var ImagesGrid_1 = __importDefault(require("./sections/ImagesGrid/ImagesGrid"));
var HomeMiddleSection_1 = __importDefault(require("./sections/homemiddlesection/HomeMiddleSection"));
var Sportlight_1 = __importDefault(require("./sections/Sportlight"));
var FinalMessage_1 = __importDefault(require("./sections/homefinalmessage/FinalMessage"));
function CollectionsSection() {
    var _a = (0, react_1.useState)(null), pageContent = _a[0], setPageContent = _a[1];
    var VideoData = [
        {
            featured_image: {
                id: "e74ba260-9892-4ac7-b1e8-265730d97b27",
            },
            video: "am-vOkXSSxc",
        },
    ];
    /* useEffect(() => {
      const getFeaturedCreators = async () => {
        await api.fans_homepage().then((res) => {
          setPageContent(res);
        });
      };
  
      if (!pageContent) {
        getFeaturedCreators();
      }
    }, [pageContent]); */
    {
        /* Word Rotator */
    }
    var words = (0, i18next_1.t)("homeDiscover.rotatorWords", {
        returnObjects: true,
    });
    var wordImage = [
        "https://loop-markets.directus.app/assets/64276176-f5ec-4771-8dd3-ede85d94212c",
        "https://loop-markets.directus.app/assets/c7be1f45-9cda-499d-a7e2-85f3745301fa",
        "https://loop-markets.directus.app/assets/4a6f7d16-9da7-4482-bada-de3cf22dbea4",
    ];
    var _b = (0, react_1.useState)(0), currentIndex = _b[0], setCurrentIndex = _b[1];
    (0, react_1.useEffect)(function () {
        var interval = setInterval(function () {
            setCurrentIndex(function (currentIndex) { return (currentIndex + 1) % words.length; });
        }, 3000);
        return function () {
            clearInterval(interval);
        };
    }, [currentIndex]);
    return ((0, jsx_runtime_1.jsx)("main", __assign({ className: "homepage HomePageFull" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "home" }, { children: [(0, jsx_runtime_1.jsx)(NewTop_1.default, {}), (0, jsx_runtime_1.jsx)(ImagesGrid_1.default, {}), (0, jsx_runtime_1.jsx)(HomeMiddleSection_1.default, {}), (0, jsx_runtime_1.jsx)(Sportlight_1.default, {}), (0, jsx_runtime_1.jsx)(FinalMessage_1.default, {})] })) })));
}
exports.default = CollectionsSection;
